var _circle, _circle2, _circle3, _circle4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTypingSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "62px",
    height: "62px",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 57.5,
    r: 5,
    fill: "#1d3f72"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cy",
    calcMode: "spline",
    keySplines: "0 0.5 0.5 1;0.5 0 1 0.5;0.5 0.5 0.5 0.5",
    repeatCount: "indefinite",
    values: "57.5;42.5;57.5;57.5",
    keyTimes: "0;0.335;0.67;1",
    dur: "1s",
    begin: "-0.67s"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 57.5,
    r: 5,
    fill: "#5699d2"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cy",
    calcMode: "spline",
    keySplines: "0 0.5 0.5 1;0.5 0 1 0.5;0.5 0.5 0.5 0.5",
    repeatCount: "indefinite",
    values: "57.5;42.5;57.5;57.5",
    keyTimes: "0;0.335;0.67;1",
    dur: "1s",
    begin: "-0.5025000000000001s"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 57.5,
    cy: 57.5,
    r: 5,
    fill: "#d8ebf9"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cy",
    calcMode: "spline",
    keySplines: "0 0.5 0.5 1;0.5 0 1 0.5;0.5 0.5 0.5 0.5",
    repeatCount: "indefinite",
    values: "57.5;42.5;57.5;57.5",
    keyTimes: "0;0.335;0.67;1",
    dur: "1s",
    begin: "-0.335s"
  }))), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 72.5,
    cy: 57.5,
    r: 5,
    fill: "#71c2cc"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cy",
    calcMode: "spline",
    keySplines: "0 0.5 0.5 1;0.5 0 1 0.5;0.5 0.5 0.5 0.5",
    repeatCount: "indefinite",
    values: "57.5;42.5;57.5;57.5",
    keyTimes: "0;0.335;0.67;1",
    dur: "1s",
    begin: "-0.1675s"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTypingSmall);
export default __webpack_public_path__ + "static/media/typing-small.fba198a7ead36db55b327e33c2744b71.svg";
export { ForwardRef as ReactComponent };